// React
import React, { FC, Fragment } from 'react';

// Components
import CheckBox from 'Components/CheckBox';

// Classes
import CheckBoxList from 'Components/CheckBoxList';
import withErrorBoundary from 'HOC/ErrorBoundary';
import { ProspectTree } from '../classes/visitorType.classes';

interface Props {
  prospectTree: ProspectTree;
  callback: (identifier: string) => void;
  showAdultLearner: boolean;
}

const VisitorTypeProspectTree: FC<Props> = (props: Props) => {
  const { prospectTree, callback, showAdultLearner } = props;

  const options = {
    checkList: {
      label: 'HS Student',
      id: 'hsStudent',
      value: prospectTree.hsStudent,
      members: [
        {
          label: 'HS Freshman',
          id: 'hsFreshman',
          value: prospectTree.hsFreshman,
        },
        {
          label: 'HS Sophomore',
          id: 'hsSophomore',
          value: prospectTree.hsSophomore,
        },
        {
          label: 'HS Junior',
          id: 'hsJunior',
          value: prospectTree.hsJunior,
        },
        {
          label: 'HS Senior',
          id: 'hsSenior',
          value: prospectTree.hsSenior,
        },
      ],
    },
    list: [
      {
        label: 'HS Graduate',
        id: 'hsGraduate',
        value: prospectTree.hsGraduate,
      },
      {
        label: 'College Student',
        id: 'collegeStudent',
        value: prospectTree.collegeStudent,
      },
      {
        label: 'College Graduate',
        id: 'collegeGraduate',
        value: prospectTree.collegeGraduate,
      },
      showAdultLearner && {
        label: 'Adult Learner',
        id: 'adultLearner',
        value: prospectTree.adultLearner,
      },
      {
        label: 'Middle Schooler',
        id: 'middleSchooler',
        value: prospectTree.middleSchooler,
      },
    ],
  };

  return (
    <>
      <CheckBoxList onClick={(e) => callback(e)} list={options.checkList} />
      {options.list.map((item) => {
        if (item) {
          return (
            <CheckBox
              key={item.id}
              label={item.label}
              id={item.id}
              value={item.value}
              isChecked={item.value}
              onClick={callback}
              overrideStyles={
                (item.id === 'middleSchooler' && { margin: '0 0 8px' }) || {
                  margin: '0 0 17px',
                }
              }
            />
          );
        }
        return null;
      })}
    </>
  );
};

export default withErrorBoundary(VisitorTypeProspectTree);
